import React, { useEffect } from "react"
import "react-responsive-modal/styles.css"
import { Modal } from "react-responsive-modal"

import { useDispatch } from "react-redux"
import { eu_consent, translate } from "redux/actions/main"
import { toggle_modal } from "redux/actions/modal"

import { audio } from "helper/audio"

const PolicyEU = (props) => {
  const dispatch = useDispatch()
  const { google_analytics_popup } = props.main.info
  const { policyeu } = props.modal
  const t = (key) => dispatch(translate(key))

  useEffect(() => {
    if (policyeu) {
      audio("popup").play()
    }

    // eslint-disable-next-line
  }, [policyeu])

  return (
    <Modal
      open={policyeu}
      onClose={() => dispatch(toggle_modal("policyeu", false))}
      focusTrapped={false}
      center
      showCloseIcon={false}
      closeOnOverlayClick={false}
      classNames={{
        overlay: "overlay",
        modal: "policyeu",
      }}
    >
      <div className="title">
        <span>{t("EU_TITLE_PRIVACY")}</span>
      </div>
      <div className="content">
        <div
          className="policy-content"
          dangerouslySetInnerHTML={{
            __html: google_analytics_popup?.popup_content,
          }}
        />
        <div className="button">
          <div
            className="btn btn-more"
            onClick={() => {
              audio("click").play()
              dispatch(toggle_modal("policyeumore", true))
              dispatch(toggle_modal("policyeu", false))
            }}
          >
            <span>{t("EU_MORE")}</span>
          </div>
          <div
            className="btn btn-reject"
            onClick={() => {
              audio("click").play()
              dispatch(
                eu_consent({
                  ad_storage: 0,
                  analytics_storage: 0,
                  ad_user_data: 0,
                  ad_personalization: 0,
                })
              )
            }}
          >
            <span>{t("EU_REJECT")}</span>
          </div>
          <div
            className="btn btn-accept"
            onClick={() => {
              audio("click").play()
              dispatch(
                eu_consent({
                  ad_storage: 1,
                  analytics_storage: 1,
                  ad_user_data: 1,
                  ad_personalization: 1,
                })
              )
            }}
          >
            <span>{t("EU_ALLOW")}</span>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default PolicyEU
